module.exports = __webpack_public_path__ + "arrow_silver_right.png?5b4b5547dcad1c0e5e67cfa95bec066e";


//////////////////
// WEBPACK FOOTER
// ./assets/img/arrow_silver_right.png
// module id = 37
// module chunks = 0